// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dm-a";
export var fulfillmentFormRail = "_dm-9";
export var headerTitleRow = "_dm-c";
export var orderDetailsWrapper = "_dm-7";
export var orderLinkTrigger = "_dm-2";
export var paymentInformationGrid = "_dm-h";
export var paymentSummaryColumn = "_dm-i";
export var shipmentContainer = "_dm-b";
export var shipmentDetailsMainPane = "_dm-8";
export var shipmentNavigationCard = "_dm-5";
export var shipmentNavigationRail = "_dm-3";
export var shipmentNavigationRailHeader = "_dm-4";
export var shipmentSummaryFact = "_dm-e";
export var shipmentSummaryGrid = "_dm-d";
export var shipmentSummaryMetadataRow = "_dm-f";
export var shipmentSummaryTags = "_dm-g";
export var shipmentWorkspace = "_dm-0";
export var shipmentWorkspaceContent = "_dm-6";
export var shipmentWorkspaceHeader = "_dm-1";